class Marquee {
  constructor(containerSelector, elementSelector, offset, speed) {
      this.off = offset;
      this.l = offset;
      this.marqueeElements = Array.from(document.querySelectorAll(`${containerSelector} ${elementSelector}`));
      this.speed = speed;
      this.stack = [];
      this.pause = true; // Začátkem nechceme pohyb
      this.animationFrameId = null; // Uchovává ID animačního rámce

      window.onload = () => {
        this.initializeMarquee();
        // this.setupEventListeners();
        this.setupIntersectionObserver();
     };
  }

  initializeMarquee() {
      this.marqueeElements.forEach(element => {
          const width = element.offsetWidth + this.off;
          element.style.left = `${this.l}px`;
          this.l += width;
          this.stack.push(element);
      });
  }

  moveMarquee() {
      if (!this.pause) {
          this.marqueeElements.forEach(element => {
              const currentLeft = parseFloat(getComputedStyle(element).left);
              const newLeft = currentLeft - this.speed;
              element.style.left = `${newLeft}px`;

              if (newLeft + element.offsetWidth < -130) {
                  const lastElement = this.stack[this.stack.length - 1];
                  element.style.left = `${parseFloat(getComputedStyle(lastElement).left) + lastElement.offsetWidth + this.off}px`;
                  this.stack.push(this.stack.shift());
              }
          });

          this.animationFrameId = requestAnimationFrame(() => this.moveMarquee());
      }
  }

  setupEventListeners() {
      const marqueeContainer = document.querySelector('.js-Marquee');
      marqueeContainer.addEventListener('mouseover', () => {
          this.pause = true;
          cancelAnimationFrame(this.animationFrameId);
      });

      marqueeContainer.addEventListener('mouseout', () => {
          this.pause = false;
          this.moveMarquee(); // Spustíme znovu animaci
      });
  }

  setupIntersectionObserver() {
      const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.5 // Více než 50% elementu je viditelné
      };

      const observer = new IntersectionObserver(entries => {
          const isVisible = entries[0].isIntersecting;
          this.pause = !isVisible;

          if (isVisible) {
              this.moveMarquee(); // Spustíme animaci, pokud je element viditelný
          } else {
              cancelAnimationFrame(this.animationFrameId);
          }
      }, options);

      observer.observe(document.querySelector('.js-Marquee'));
  }
}

if(document.querySelector('.js-Marquee')){
  new Marquee('.js-Marquee', 'span', 0, 1);
}
